(function(){
  function run(){
    var LOGO = window.PPP_LOGO || '';
    var MARK = window.PPP_MARK || '';
    if (MARK) {
      document.querySelectorAll('[id*=header_section] a').forEach(function(a){
        if (a.getAttribute('data-ppp-mark') || !/^\s*Pre&Post Pulse\s*$/.test(a.textContent)) return;
        a.setAttribute('data-ppp-mark','1');
        var m=document.createElement('img'); m.src=MARK; m.alt=''; m.width=40; m.height=40;
        m.style.cssText='width:40px;height:40px;margin-right:10px;flex:none;display:inline-block;vertical-align:middle';
        a.style.display='inline-flex'; a.style.alignItems='center';
        a.insertBefore(m, a.firstChild);
      });
    }
    function swapText(sel, test, html){
      document.querySelectorAll(sel).forEach(function(el){
        if (test.test(el.textContent)) { el.innerHTML = html; }
      });
    }
    // R13: no "75" in public copy
    swapText('#ppp .founding .badge, span.badge', /Only 75 spots/i, 'Limited Founding spots');
    swapText('#ppp h2', /first 75 get founding status/i, 'Founding status is limited. <span class="o">And it’s for life.</span>');
    swapText('#ppp li', /only 75 people/i, 'The Founding Member title — only a limited number of members will ever have it.');
    swapText('#ppp .note, #ppp div', /^\s*Once the 75 spots are gone, they.re gone\.\s*$/i, 'Once they’re gone, they’re gone.');
    // stale holiday/December copy
    swapText('#ppp .closing p.body', /ship right before the holidays/i, 'Try it yourself, or give it to the lifter in your life — the gift that actually gets used, not re-gifted. Founding price, founding shaker, first dibs on everything. Founding spots are limited.');
    swapText('footer p, [id*=footer] p', /first 75 to join become Founding Members/i, 'Founding Member spots are limited — your founding price is yours for life.');
    // new logo
    if (LOGO) {
      document.querySelectorAll('svg.pd-badge').forEach(function(sv){
        var i=document.createElement('img'); i.src=LOGO; i.alt='Pre&Post Pulse';
        i.style.cssText='width:120px;height:120px;display:block;margin:0 auto 10px';
        sv.replaceWith(i);
      });
      document.querySelectorAll('.logo').forEach(function(el){
        if (/PrePostPulse_Master_Logo/.test(getComputedStyle(el).backgroundImage)) {
          el.style.backgroundImage = 'url(' + LOGO + ')';
        }
      });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  window.addEventListener('load', run);
})();
